<template>
  <li class="col-12 overview-item listed-search-download">
    <div class="card">

      <a class="link card-link" :href="url || '#'" target="_self"  role="navigation">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="card-title">
                <h2 class="card-title-heading">
                  <span class="row">
                    <span class="col-12 col-md-9">
                      {{ title }}
                    </span>
                    <span class="col-12 col-md-3 text-right">
                      <template v-if="badges">
                        <span
                          v-for="(badge, index) in badges" v-bind:key="index"
                          :class="`badge border border-dark text-dark${(parseInt(index) > 0) ? ' ml-1' : ''}`"
                          >
                          {{ badge }}
                        </span>
                      </template>
                    </span>
                  </span>
                </h2>
              </div>
              <!-- instead of highlight display description -->
              <!--p v-if="highlight" v-html="sanitizeHtml(`&hellip;&nbsp;${highlight}&nbsp;&hellip;`)" class="card-text"></p-->
              <p v-if="item && item['description']" class="card-text card-asset-description" v-html="(item['description'])"></p>
              <p class="card-text card-asset-lastmodified"><span class="text-gray-dark">Zuletzt aktualisiert: </span>{{ lastModified }}</p>
            </div>
          </div>
        </div>
      </a>
      <template v-if="dependants && dependants.length > 0" >
        <p class="breadcrumb mb-0 pb-0" v-for="(depItem, outerIndex) in ((dependants && dependants.slice(0,3)) || [])" v-bind:key="outerIndex">
          <!-- TODO make dependant count configurable? -->
            <template v-for="(ancItem, innerIndex) in (depItem.ancestors || [])" v-bind:key="innerIndex">
              <a :href="sanitizeUrl(ancItem.link || '#')">
                {{ ancItem.title || 'Kein Titel' }}
              </a>
              <span v-if="(innerIndex + 1) <= depItem.ancestors.length"> / </span>
            </template>
            <a :href="sanitizeUrl(depItem.link || '#')">
              {{ depItem.title || 'Kein Titel' }}
            </a>
        </p>
      </template>

    </div>
    <div class="badge" aria-hidden="true"></div>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { formatMonth, formatYear, formatDate } from '../../utils/dateUtils'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { sanitizeHtml } from '@/utils/domUtils'

export default defineComponent({
  name: 'Asset',
  props: {
    item: Object,
    highlight: String,
    nodeLink: Object,
    dependants: Object,
    ancestors: Object,
    badges: Object,
  },
  data() {
    return {
      sanitizeUrl: sanitizeUrl,
      sanitizeHtml: sanitizeHtml
    };
  },
  computed: {
    month(): string {
      if (this.item && this.item['comparable_date_dt']) {
        return formatMonth(this.item['comparable_date_dt'])
      } else if (this.item && this.item['last_modified']) {
        return formatMonth(this.item['last_modified'])
      }
      return ''
    },
    year(): string {
      if (this.item && this.item['comparable_date_dt']) {
        return formatYear(this.item['comparable_date_dt'])
      } else if (this.item && this.item['last_modified']) {
        return formatYear(this.item['last_modified'])
      }
      return ''
    },
    lastModified(): string {
      if (this.item && this.item['comparable_date_dt']) {
        return formatDate(this.item['comparable_date_dt'], 'DD.MM.YYYY')
      } else if (this.item && this.item['last_modified']) {
        return formatDate(this.item['last_modified'], 'DD.MM.YYYY')
      }
      return ''
    },
    title(): string {
      return (this.item && ((this.item['title'] && this.item['title'][0])
        || (this.item['filename_t'] && this.item['filename_t'][0])
        || (this.item['name'] && this.item['name'][0])
      )) || 'Kein Titel'
    },
    url(): string {
      if (this.nodeLink && this.nodeLink.link) {
        return sanitizeUrl(this.nodeLink.link)
      } else if (this.item && this.item['url'] && this.item['url'][0]) {
        return sanitizeUrl(this.item.url[0])
      }
      return '#'
    }
  }
});
</script>
<style scoped>
  .card-asset-description {
    margin-bottom: 0 !important;
  }
  .card-asset-lastmodified {
    color: #00436B !important;
    margin-top: .4375rem;
  }
  .text-gray-dark {
    color: #343a40;
  }
</style>
